// @ts-nocheck
import client from "../../utils/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { VisitorVisitorApprovalPassedMutationRequest, VisitorVisitorApprovalPassedMutationResponse, VisitorVisitorApprovalPassedPathParams, VisitorVisitorApprovalPassed401 } from "../models/VisitorVisitorApprovalPassed";
import type { UseMutationOptions } from "@tanstack/react-query";

 type VisitorVisitorApprovalPassedClient = typeof client<VisitorVisitorApprovalPassedMutationResponse, VisitorVisitorApprovalPassed401, VisitorVisitorApprovalPassedMutationRequest>;
type VisitorVisitorApprovalPassed = {
    data: VisitorVisitorApprovalPassedMutationResponse;
    error: VisitorVisitorApprovalPassed401;
    request: VisitorVisitorApprovalPassedMutationRequest;
    pathParams: VisitorVisitorApprovalPassedPathParams;
    queryParams: never;
    headerParams: never;
    response: VisitorVisitorApprovalPassedMutationResponse;
    client: {
        parameters: Partial<Parameters<VisitorVisitorApprovalPassedClient>[0]>;
        return: Awaited<ReturnType<VisitorVisitorApprovalPassedClient>>;
    };
};
/**
 * @summary 访客审批通过
 * @link /api/v5/visitors/:id/visitor-approval-passed
 */
export function useVisitorVisitorApprovalPassed(options: {
    invalidationOnSuccess?: boolean;
    mutation?: UseMutationOptions<VisitorVisitorApprovalPassed["response"], VisitorVisitorApprovalPassed["error"], {
        id: VisitorVisitorApprovalPassedPathParams["id"];
        data?: VisitorVisitorApprovalPassed["request"];
    }>;
    client?: VisitorVisitorApprovalPassed["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    const queryClient = useQueryClient();
    let invalidationOnSuccessOption = options?.invalidationOnSuccess ?? true;
    return useMutation({
        mutationFn: async ({ id, data }) => {
            const res = await client<VisitorVisitorApprovalPassed["data"], VisitorVisitorApprovalPassed["error"], VisitorVisitorApprovalPassed["request"]>({
                method: "post",
                url: `/api/v5/visitors/${id}/visitor-approval-passed`,
                data,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions,
        onSuccess: (...args) => {
            if (invalidationOnSuccessOption) {
                queryClient.invalidateQueries({
                    queryKey: ["api", "v5", "visitors"]
                });
            }
            if (mutationOptions?.onSuccess)
                mutationOptions.onSuccess(...args);
        },
    });
}